import { createAction } from '@reduxjs/toolkit';
export const fetchAccountSagaAction = createAction('account/getAccount');
export const saveAccountSagaAction = createAction('account/saveAccount');
